const pt = {
  metaTitle: "FearGreed — Botão de Sentimento Crypto",
  metaDescription: "O Crypto Fear & Greed Index como um botão tátil. Atualizações programadas de alternative.me. Sem contas, sem rastreamento.",

  navAbout: "Docs",
  footerPrivacy: "Privacidade",
  footerSupport: "Suporte",
  footerAbout: "Docs",
  footerDataSource: "Dados: alternative.me · Não é aconselhamento financeiro",

  loading: "Carregando…",
  unableToLoad: "Não foi possível carregar o índice",
  somethingWentWrong: "Algo deu errado.",
  tryAgain: "Tentar novamente",
  lastUpdated: "Atualizado {time}",
  updating: "Atualizando…",
  buttonUpdated: "Atualizado ✓",
  nowLabel: "{value} ({bucket})",
  sourceLabel: "Fonte: alternative.me",
  ariaButton: "{value} {bucket} — Índice Fear and Greed. Toque para um insight.",

  ritualDisclaimer: "Não é aconselhamento financeiro",

  infoTitle: "Índice Fear & Greed",
  infoDescription: "Pontuação de sentimento do mercado crypto (0–100). Volatilidade, momentum, redes sociais, pesquisas. Fonte: alternative.me. Não é aconselhamento financeiro.",
  infoAttribution: "Dados de alternative.me Crypto Fear & Greed Index.",
  info7d: "Tendência 7 dias",
  info30d: "Tendência 30 dias",
  infoNextUpdate: "Próxima atualização",
  infoInterpretTitle: "Como interpretar",
  infoInterpretExtremeFear: "0–24: Medo Extremo. Historicamente precedeu algumas recuperações.",
  infoInterpretExtremeGreed: "75–100: Ganância Extrema. Historicamente precedeu algumas correções.",
  infoDisclaimer: "Apenas indicador de sentimento. Padrões passados não preveem resultados futuros. Faça sua própria pesquisa.",
  infoApiTitle: "API",
  infoPulseTitle: "Pulse",
  infoDocsLink: "Documentação completa e referência da API",

  backToButton: "Voltar",

  aboutTitle: "Docs",
  aboutWhatTitle: "O que é o FearGreed?",
  aboutWhat: "Exibe o Crypto Fear & Greed Index — uma pontuação diária de sentimento (0–100) calculada pela alternative.me a partir de volatilidade, momentum, redes sociais, pesquisas, dominância e tendências. Um sinal. Sem ruído.",
  aboutWhyTitle: "Por que o FearGreed?",
  aboutWhyIntro: "O índice bruto é um número. O FearGreed o transforma em produto.",
  aboutWhy1Title: "UX ritualizada",
  aboutWhy1: "Um botão tátil. Sem gráficos, sem ruído, sem dashboards. Toque, leia, siga em frente.",
  aboutWhy2Title: "Sincronização programada",
  aboutWhy2: "Verifica novos dados via janelas cron programadas, alinhadas com o ciclo de atualização diário da fonte.",
  aboutWhy3Title: "Análises derivadas",
  aboutWhy3: "Delta, médias móveis, inclinação, duração do regime, rótulos de vigilância — calculados a partir dos dados brutos, não disponíveis na fonte.",
  aboutWhy4Title: "Pulse em linguagem natural",
  aboutWhy4: "Frase de insight diária gerada por IA. Contextual, não genérica.",
  aboutWhy5Title: "Market tape",
  aboutWhy5: "Variações 24h BTC/ETH, capitalização de mercado, dominância, volume e rótulo de pressão. Atualizado a cada 4 horas.",
  aboutWhy6Title: "Para agentes",
  aboutWhy6: "Endpoints JSON estruturados, llms.txt, especificação OpenAPI e badge SVG. Construído para consumo programático.",
  aboutSourceTitle: "Fonte de dados",
  aboutSource: "Dados de alternative.me. A fonte é tipicamente atualizada uma vez por dia por volta das 00:00 UTC. O FearGreed verifica novos dados via janelas cron programadas alinhadas com este horário.",
  aboutApiTitle: "API",
  aboutApiDescription: "Endpoints públicos. CORS habilitado. JSON salvo indicação contrária. Sem autenticação necessária.",
  aboutApiLatest: "Último valor com análises derivadas: delta, médias, distância do neutro.",
  aboutApiHistory: "Últimos 30 valores diários com bucket e cor.",
  aboutApiSummary: "Resumo em texto simples. Útil para LLMs e agentes.",
  aboutApiBadge: "Badge SVG. Para READMEs ou dashboards.",
  aboutApiContext: "Contexto diário gerado por IA com indicação de tendência e todas as análises derivadas. Cache de 1h.",
  aboutApiPulse: "Análises estruturadas: regime, sinal, inclinação, médias. Sem IA. Cache 15min.",
  aboutApiTape: "Variações 24h BTC/ETH, capitalização, dominância, volume e rótulo de pressão. Cache 30min.",
  aboutBadgeTitle: "Badge / Embed estático",
  aboutBadgeDescription: "Incorpore o índice atual como badge SVG:",
  aboutEmbedTitle: "Embed interativo",
  aboutEmbedDescription: "Incorpore o botão interativo completo em qualquer página via iframe. Mesma sensação tátil, sem chrome, apenas dados em cache.",
  aboutCurlTitle: "Exemplo de requisição",
  aboutJsonExample: "Exemplo de resposta (Latest)",
  aboutLlmsTxtTitle: "llms.txt",
  aboutLlmsTxtDescription: "Resumo do projeto legível por máquinas para agentes LLM e crawlers.",
  aboutOpenapiTitle: "OpenAPI",
  aboutOpenapiDescription: "Especificação API completa no formato OpenAPI 3.0.",
  aboutDisclaimerTitle: "Aviso legal",
  aboutDisclaimer: "Apenas utilidade de sentimento. Não prevê movimentos de preço. Não é aconselhamento financeiro. Faça sua própria pesquisa.",
  aboutNonAffiliation: "FearGreed é uma interface independente. Não é afiliado nem endossado pela alternative.me.",
  staleIndicator: "Offline · dados em cache",
  infoButton: "Mais informações",
  languageSelector: "Idioma",
  themeToggle: "Alternar tema",

  privacyTitle: "Política de Privacidade",
  privacyEffectiveDate: "Data de vigência: 8 de março de 2026",
  privacySummaryTitle: "Resumo",
  privacySummary: "O FearGreed não requer login, não cria contas e não coleta dados pessoais.",
  privacyDataTitle: "Dados coletados",
  privacyData: "Nenhum. Sem cadastros, sem cookies de rastreamento, sem perfis analíticos.",
  privacyTechTitle: "Dados técnicos",
  privacyTech: "A infraestrutura de hospedagem pode registrar endereços IP e timestamps para confiabilidade. Não vinculados a usuários individuais.",
  privacyThirdPartyTitle: "Serviços de terceiros",
  privacyThirdParty: "O FearGreed obtém dados da API alternative.me. Consulte a política de privacidade deles.",
  privacyAdsTitle: "Publicidade",
  privacyAds: "O FearGreed não exibe publicidade.",
  privacyChangesTitle: "Alterações",
  privacyChanges: "Atualizações serão publicadas nesta página com data de vigência revisada.",
  privacyContactTitle: "Contato",
  privacyContact: "Perguntas? Entre em contato em",

  supportTitle: "Suporte",
  supportDescription: "Para dúvidas ou problemas, entre em contato em:",

  bucketExtremeFear: "Medo Extremo",
  bucketFear: "Medo",
  bucketNeutral: "Neutro",
  bucketGreed: "Ganância",
  bucketExtremeGreed: "Ganância Extrema",

  pulseLabel: "Pulse:",
  regimeSuffix: "regime {days}d",
  watchFearDeepening: "Medo Aprofundando",
  watchFearStabilizing: "Medo Estabilizando",
  watchNeutralCompression: "Compressão Neutra",
  watchGreedAccelerating: "Ganância Acelerando",
  watchGreedOverheating: "Ganância Superaquecendo",
  watchPossibleReversal: "Possível Reversão",
  watchTrendPersistence: "Tendência Persistente",
  watchRecoveryBuilding: "Recuperação em Construção",

  infoRegimePulse: "Regime e Pulse",
  infoMarketTape: "Market Tape",
  infoPressure: "Pressão",

  updateAvailable: "Atualização disponível",

  aboutViewLlmsTxt: "Ver llms.txt",
  aboutViewOpenapi: "Ver openapi.json",

  // Market pressure labels
  pressureBroadSellOff: "Venda generalizada",
  pressureUnderPressure: "Sob pressão",
  pressureBroadRally: "Rally generalizado",
  pressureRiskAppetite: "Apetite por risco melhorando",
  pressureFlat: "Mercado estável",
  pressureMixed: "Sinais mistos",

  notFoundTitle: "Página não encontrada",
  notFoundBack: "Voltar para o início",

  hintTap: "pressione aqui",
} as const;

export default pt;
